import Box from "@mui/material/Box";
import { useRef, useEffect, useState } from "react";

const VIDEO_URL =
  "https://contact-app-prod.s3.us-east-2.amazonaws.com/Branch-POS/news.mp4";

const REFRESH_INTERVAL = 30 * 60 * 1000; // 30 minutes

export default function BranchesVideo() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [videoVersion, setVideoVersion] = useState(Date.now());

  const videoSrc = `${VIDEO_URL}?v=${videoVersion}`;

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.muted = true;
      video.play().catch(() => {});
    }

    const unmuteAndPlay = () => {
      if (video) {
        video.muted = false;
        video.play().catch(() => {});
        setMuted(false);

        document.removeEventListener("click", unmuteAndPlay);
        document.removeEventListener("touchstart", unmuteAndPlay);
      }
    };

    document.addEventListener("click", unmuteAndPlay);
    document.addEventListener("touchstart", unmuteAndPlay);

    return () => {
      document.removeEventListener("click", unmuteAndPlay);
      document.removeEventListener("touchstart", unmuteAndPlay);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setVideoVersion(Date.now());
    }, REFRESH_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.load();
      video.play().catch(() => {});
    }
  }, [videoSrc]);

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        m: 0,
        p: 0,
        overflow: "hidden",
      }}
    >
      <Box
        ref={videoRef}
        component="video"
        src={videoSrc}
        width="100%"
        height="100%"
        autoPlay
        loop
        playsInline
        muted={muted}
        controls={false}
        preload="metadata"
        sx={{
          objectFit: "cover",
          display: "block",
        }}
      />
    </Box>
  );
}